import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Extension } from 'src/app/app.models';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { ExtensionService } from 'src/app/services/extension.service';
import { HostService } from 'src/app/services/host.service';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';

@Component({
  selector: 'app-p-proprietaire',
  templateUrl: './p-proprietaire.component.html',
  styleUrls: ['./p-proprietaire.component.scss']
})
export class PProprietaireComponent implements OnInit, OnDestroy {

  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;
  //Subscription
  extensionSubscription: Subscription;

  //boolean
  extensionGetted: boolean;

  user: any;

  extensions: any;

  //displayedColumns: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'numberOfDay', 'status', 'date', 'renting', 'actions'];
  displayedColumns: string[] = ['image', 'mark', 'dateStart', 'dateEnd', 'price', 'numberOfDay', 'status', 'date',  'actions'];

  dataSource!: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(private authService: AuthService, private router: Router,
              private extensionService: ExtensionService, 
              public hostService: HostService, public spinner: NgxSpinnerService,
              private toastr: ToastrService, public appService: AppService,
              private verifResponsiveService:VerifResponsiveService
              ) { }

  ngOnInit(): void {

    this.initProperty();
    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      console.log(data);
      this.viewType = data ? 'grid' : 'list';
    });
  }

  initProperty() {

    let res = this.authService.getUserOfLocalStorage();
    
    if(res.status) {

      this.user = JSON.parse(localStorage.getItem("user")!)
    
      this.getExtension();

    } else {

      this.extensionGetted = false;

      this.router.navigate(['login']);

    }

  }

  private getExtension() {

      this.extensionSubscription = this.extensionService.indexOwner(this.user.id).subscribe((data: any) => {

        console.log(data);

        this.extensions = data.extensions;
      
      this.dataSource = new MatTableDataSource(data.extensions);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort; 


      })
  }


  /**
   * Filtre 
   * 
   * @param event 
   */
  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();

  } 

  /**
   * Modifier le status de la prolongation
   * 
   * @param extension 
   */
  changeStatus(extension: any, status: string) {

    this.spinner.show();

    let obj = {
      'id': extension.id,
      'status': status
    };

    this.extensionSubscription = this.extensionService.changeStatus(obj).subscribe((response: any) => {

      console.log(response);

      this.toastr.success('Le status de la prolongation du '+extension.renting_date_return+' au '+extension.extension_date_return+' a été modifié avec success');

      this.getExtension();

      this.spinner.hide();
      
    })
  }

  ngOnDestroy(): void {
    
    if(this.extensionGetted) {

      this.extensionSubscription.unsubscribe();

    }
  }

  
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

  refresh() {
    //window.location.reload();
   //location.reload();
    this.getExtension();
    
  }

}
